import { useState, useEffect } from "react";
import API from "@/lib/api";
import { Target, Star } from "lucide-react";

export const STUDENT_GOAL_MESSAGE =
  "Every fact needs to be right 3 times in a row, fast. Your goal is 20 new facts each week. Tuesday and Thursday, try your best, don't guess, and watch your progress bar fill up!";

export default function WeeklyGoalCard() {
  const [w, setW] = useState(null);

  useEffect(() => {
    API.get("/student/weekly").then(({ data }) => setW(data)).catch(() => {});
  }, []);

  const goal = w?.goal ?? 20;
  const done = w?.facts_mastered ?? 0;
  const pct = Math.min(100, Math.round((done / goal) * 100));
  const met = done >= goal;
  const message = STUDENT_GOAL_MESSAGE.replace("20 new facts", `${goal} new facts`);

  return (
    <div className="glass-surface rounded-xl p-6 mb-10 border border-cyber/20" data-testid="weekly-goal-card">
      <div className="flex items-start gap-4 mb-5">
        <div className="p-2.5 rounded-lg bg-cyber/10 shrink-0">
          <Target className="w-6 h-6 text-cyber" />
        </div>
        <div>
          <h2 className="font-heading text-lg font-bold text-white mb-1">Your Weekly Mission</h2>
          <p className="font-body text-sm text-white/70 leading-relaxed" data-testid="weekly-goal-message">{message}</p>
        </div>
      </div>
      <div className="flex items-center justify-between mb-2">
        <span className="font-body text-sm text-white/60">This week</span>
        <span className={`font-mono text-sm font-bold ${met ? "text-[#39FF14]" : "text-cyber"}`} data-testid="weekly-goal-count">
          {done} / {goal} facts {met && <Star className="inline w-4 h-4 -mt-0.5 fill-current" />}
        </span>
      </div>
      <div className="h-3 rounded-full bg-white/5 overflow-hidden" data-testid="weekly-goal-bar">
        <div
          className={`h-full rounded-full transition-[width] duration-700 ${met ? "bg-[#39FF14]" : "bg-cyber"}`}
          style={{ width: `${pct}%`, boxShadow: `0 0 12px ${met ? "#39FF14" : "#00F0FF"}` }}
        />
      </div>
      <p className="font-body text-xs text-white/40 mt-2" data-testid="weekly-goal-status">
        {met ? "Goal reached! Every extra fact gets you closer to the next band." : `${goal - done} more to reach this week's goal.`}
      </p>
    </div>
  );
}
